import { Component, Prop, Vue } from 'nuxt-property-decorator';

@Component
export default class PageBlockMixin extends Vue {
    @Prop(String) head!: string;
    @Prop({ required: false, default: '' }) text: string;
}
